import { render, staticRenderFns } from "./Formularios.vue?vue&type=template&id=b9ad23e4&scoped=true&"
import script from "./Formularios.vue?vue&type=script&lang=js&"
export * from "./Formularios.vue?vue&type=script&lang=js&"
import style0 from "./Formularios.vue?vue&type=style&index=0&id=b9ad23e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ad23e4",
  null
  
)

export default component.exports